import { downgradeComponent } from '@angular/upgrade/static';
import { DiscoverPageComponent, MyWorkEmptyStateComponent } from '@mode/home/ui';
import * as angular from 'angular';

export const DowngradedHomeUIModule = angular
  .module('downgraded-home-ui', [])
  .directive('modeMyWorkEmptyState', downgradeComponent({ component: MyWorkEmptyStateComponent }))
  .directive('modeDiscoverPage', downgradeComponent({ component: DiscoverPageComponent })).name;
